import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../dashboard/DashboardLayout';
import DynamicForm from '../../../components/dynamicForm';
import { publicProfileSchema } from '../../../formData/publicProfileSchema';
import { showSuccess } from '../../../components/showSuccess';

export default function PublicProfilePage() {
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);
  const [activeTab, setActiveTab] = useState('company');

  useEffect(() => {
    // fetch existing data from API, mocked here
    const fetched = {
      companyName: 'ACME Corp',
      phonePrefix: '+1',
      phone: '1234567890',
      fax: '0987654321',
      address: '123 Main St, Anytown, USA',
      thumbnail: null,
    };
    setInitialData(fetched);
  }, []);

  const handleAction = async (action, data) => {
    if (action === 'cancel') {
      navigate(-1);
    }
    if (action === 'update') {
      // TODO: persist via API
      await showSuccess('Company Details Updated Successfully!');
      navigate(-1);
    }
  };

  if (!initialData) return null;

  return (
    <>
      <div style={styles.container}>
        <h1 style={styles.title}>Public Profile</h1>

        <div style={styles.tabs}>
          {publicProfileSchema.tabs.map(tab => (
            <div
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                ...styles.tab,
                ...(activeTab === tab.key ? styles.tabActive : {})
              }}
            >
              {tab.label}
            </div>
          ))}
        </div>

        <div style={styles.formCard}>
          <DynamicForm
            formStyle={activeTab === 'payment' ? styles.formStylePayment : styles.formStyle}
            schema={publicProfileSchema.schemas[activeTab]}
            mode="edit"
            initialData={initialData}
            onAction={handleAction}
            buttonHolderStyle={styles.buttonHolderStyle}
            actionButtonStyle={styles.actionButtonStyle}
          />
        </div>
      </div>
    </>
  );
}

const styles = {
  container: {
    margin: '0 auto',
    color: '#333',
  },
  title: {
    fontSize: 24,
    marginTop: 0,
    color: '#4a5568',
  },
  tabs: { display: 'flex', background: '#f3f3f3', borderRadius: 4, overflow: 'hidden' },
  tab: { padding: '12px 16px', cursor: 'pointer', color: '#666' },
  tabActive: { background: '#fff', color: '#000', borderBottom: '2px solid #7c4dff' },
  formCard: { background: '#fff', borderRadius: 8, padding: 24, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' },
  actionButtonStyle: {
    maxWidth: '150px'
  },
  buttonHolderStyle: {
    marginTop: '44vh',
    width: '100%',
    float: 'right',
    borderTop: 'solid 1px #ccc',
    paddingTop: '34px',
    justifyContent: 'right'
  },
  formStyle: {
    marginTop: '24px',
    display: 'inline-block'
  },
  formStylePayment: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 50
  },
};